"use client";

import React, { createContext, useContext, ReactNode } from "react";

interface SessionUser {
  id: string;
  email: string;
  name: string | null;
  role: string;
}

interface SessionContextType {
  user: SessionUser | null;
  isLoading: boolean;
}

const SessionContext = createContext<SessionContextType | undefined>(undefined);

export interface SessionProviderProps {
  children: ReactNode;
  user: SessionUser | null;
  isLoading?: boolean;
}

export function SessionProvider({
  children,
  user,
  isLoading = false,
}: SessionProviderProps) {
  return (
    <SessionContext.Provider value={{ user, isLoading }}>
      {children}
    </SessionContext.Provider>
  );
}

export function useSession() {
  const context = useContext(SessionContext);
  if (context === undefined) {
    throw new Error("useSession must be used within a SessionProvider");
  }
  return context;
}
